<template>
    <div class="w-full">
        <custom-input
            v-show="showString"
            ref="inputMoneyString"
            v-model="priceString"
            type="text"
            :label="label"
            :error="messageError"
            :disabled="!enabled"
            @input="formatPrice"
            @focus="onFocus"
            @click-icon="onClickIcon"
        >
            <template v-if="icon" #icon> {{ icon }} </template>
        </custom-input>
        <custom-input
            v-show="!showString"
            ref="inputMoneyNumber"
            v-model="priceNumber"
            type="text"
            :label="label"
            :error="messageError"
            :disabled="!enabled"
            @input="onInput"
            @blur="onBlur"
            @enter="onEnter"
            @click-icon="onClickIcon"
        >
            <template v-if="icon" #icon> {{ icon }} </template>
        </custom-input>
    </div>
</template>

<script>
import { parseMoneyShorthand, sanitizeMoneyInput } from "@/common/lib/money";

import CustomInput from "@/components/utils/CustomInput.vue";

export default {
    name: "InputMoneyComponent",
    components: {
        CustomInput
    },
    model: {
        prop: "itemCurrent",
        event: "input"
    },
    props: {
        itemCurrent: {
            type: [Number, null],
            required: true,
            validator: (value) =>
                value === null ||
                value === undefined ||
                typeof value === "number",
            default: null
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        label: {
            default: () => "Precio",
            type: String,
            required: false
        },
        icon: {
            default: () => "",
            type: String,
            required: false
        },
        min: {
            default: () => 0,
            type: Number,
            required: false
        },
        messageError: {
            default: () => "",
            type: String,
            required: false
        }
    },
    emits: ["input", "blur", "click-icon", "enter"],
    data: () => ({
        priceString: "",
        priceNumber: "",
        showString: true
    }),
    watch: {
        itemCurrent(value) {
            if (!this.showString) return;
            this.setInput(value);
        },
        enabled() {
            if (this.priceString === "-") {
                this.priceString = "0";
            }
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    methods: {
        onFocus() {
            this.$emit("focus");
            this.showString = false;
            setTimeout(() => {
                try {
                    this.$refs.inputMoneyNumber.$refs.input.focus();
                } catch (error) {
                    console.error("Error in focus %o", error);
                }
            }, 100);
        },
        onBlur() {
            this.$emit("blur");
            this.formatPrice();
            this.showString = true;
        },
        onClickIcon() {
            this.$emit("click-icon");
        },
        onEnter() {
            this.formatPrice();
            this.showString = true;
            this.$emit("enter");
        },
        onInput() {
            this.$emit("input", this.formatPrice());
        },
        formatPrice() {
            this.priceNumber = sanitizeMoneyInput(this.priceNumber);
            const numericValue = parseMoneyShorthand(this.priceNumber);
            this.priceString = this.$options.filters.currency(numericValue);
            return numericValue;
        },
        setInput(value) {
            if (value === null) {
                this.priceString = "-";
                this.priceNumber = "";
                return;
            }
            this.priceNumber = String(value || 0);
            this.priceString = this.$options.filters.currency(value);
        }
    }
};
</script>
